module.exports = __webpack_public_path__ + "img/logo_light.7030fc14.svg";